import { styled, Theme } from '@mui/material';
import { palette } from 'view/themes/palette';

export const Wrapper = styled('div')(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    minHeight: '100vh',
    height: 'auto',
    width: '100%',
    padding: '2rem',
    gap: '1.5rem',
    backgroundColor: palette.background.general,

    [theme.breakpoints.down('tablet')]: {
      padding: 0,
    },
  };
});

export const LeftBlock = styled('div')(({ theme }: { theme: Theme }) => {
  return {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '1.5rem',
    borderRadius: '1.5rem',
    backgroundColor: palette.background.clear_white,

    [theme.breakpoints.down('desktop')]: {
      width: '100%',
    },

    [theme.breakpoints.down('tablet')]: {
      padding: '1rem',
      borderRadius: 0,
    },
  };
});

export const RightBlock = styled('div')(({ theme }: { theme: Theme }) => {
  return {
    width: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '1.5rem',
    backgroundColor: palette.background.branded_purple,

    [theme.breakpoints.down('desktop')]: {
      display: 'none',
    },
  };
});
